import React from "react";

const services = [
	"Enterprise Software Development",
	"IT Infrastructure & Support",
	"Cybersecurity & Compliance",
	"Cloud Solutions & Migration",
	"Digital Strategy & Consulting",
];

const Services = () => (
	<section className="py-16 bg-gray-50" id="services">
		<div className="max-w-5xl mx-auto px-4">
			<h3 className="text-4xl font-bold mb-6 text-yellow-500">What We Offer</h3>
			<div className="grid md:grid-cols-2 gap-6 text-gray-700">
				{services.map((service, index) => (
					<div
						key={index}
						className="bg-white p-4 rounded shadow hover:shadow-md transition"
					>
						<h4 className="font-semibold text-lg">{service}</h4>
					</div>
				))}
			</div>
		</div>
	</section>
);

export default Services;
